import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Container,
} from "@mui/material";
import {
  PersonAdd,
  CheckCircle,
  ErrorOutline,
  VpnKey,
  WarningAmber,
} from "@mui/icons-material";

const activities = [
  {
    company: "Acme Corporation",
    initials: "AC",
    color: "#dce9ff",
    icon: <PersonAdd color="primary" />,
    activity: "New user added",
    user: "John Matthews (Admin)",
    time: "10 minutes ago",
  },
  {
    company: "Widget Industries",
    initials: "WI",
    color: "#f3e8ff",
    icon: <CheckCircle sx={{ color: "green" }} />,
    activity: "QA process completed",
    user: "Sarah Johnson (Admin)",
    time: "1 hour ago",
  },
  {
    company: "TechTron Inc.",
    initials: "TT",
    color: "#ffe7e7",
    icon: <ErrorOutline sx={{ color: "red" }} />,
    activity: "Payment failed",
    user: "System",
    time: "3 hours ago",
  },
  {
    company: "Global Services",
    initials: "GS",
    color: "#e6fff2",
    icon: <VpnKey sx={{ color: "#5e6ad2" }} />,
    activity: "Admin access used",
    user: "Super Admin",
    time: "6 hours ago",
  },
  {
    company: "StarCall Solutions",
    initials: "SC",
    color: "#fff6da",
    icon: <WarningAmber sx={{ color: "#f2c037" }} />,
    activity: "Usage limit warning",
    user: "System",
    time: "Yesterday",
  },
];

const RecentActivitiesTable = () => {
  return (
    <Container maxWidth="xl" sx={{ mt: 4 }}>
      <Card sx={{ borderRadius: 3 }}>
        <CardContent>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 2,
            }}
          >
            <Typography variant="h6" fontWeight={600}>
              Recent Company Activities
            </Typography>
            <Button size="small" sx={{ textTransform: "none" }}>
              View All
            </Button>
          </Box>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>COMPANY</strong>
                  </TableCell>
                  <TableCell>
                    <strong>ACTIVITY</strong>
                  </TableCell>
                  <TableCell>
                    <strong>USER</strong>
                  </TableCell>
                  <TableCell>
                    <strong>TIME</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {activities.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                      >
                        <Avatar
                          sx={{
                            width: 32,
                            height: 32,
                            fontSize: 14,
                            bgcolor: item.color,
                            color: "black",
                          }}
                        >
                          {item.initials}
                        </Avatar>
                        <Typography>{item.company}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        {item.icon}
                        <Typography>{item.activity}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Typography>{item.user}</Typography>
                    </TableCell>
                    <TableCell>
                      <Typography>{item.time}</Typography>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Container>
  );
};

export default RecentActivitiesTable;
